export {default} from './logout.vue'